import './../../external/@lit/reactive-element/reactive-element.js';
import './../../external/lit-html/lit-html.js';
import './../../external/lit-element/lit-element.js';
import { css as i } from './../../external/@lit/reactive-element/css-tag.js';
var ModalDialogCss = i`
  :host {
    font-family: var(--isceco-font);
  }

  .gray-overlay {
    position: fixed;
    z-index: 98;
    top: 0;
    left: 0;
    margin: 0;
    width: 100vw;
    height: 100vh;
    background-color: var(--isceco-color-grey-900);
    opacity: 50%;
  }

  .dialog-container {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    margin: 0;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: none;
  }

  .dialog {
    background-color: var(--isceco-color-white-500);
    padding: var(--isceco-space-300);
    box-shadow: 0 1px 4px 0 #0000001F;
    border-radius: var(--isceco-space-100);
    overflow: hidden auto;
    color: var(--isceco-color-black-500);
    box-sizing: border-box;
    max-height: 90vh;
    pointer-events: auto;
  }

  .dialog > .dialog-header {
    margin: 0 0 var(--isceco-space-200);
    font-size: 1.25rem;
  }

  .dialog > .dialog-content > * {
    margin: 0 0 var(--isceco-space-200);
    color: var(--isceco-color-grey-900);
  }

  .dialog > .dialog-content > p {
    white-space: pre-line;
  }

  .dialog-buttons {
    margin-top: var(--isceco-space-300);
    display: flex;
    justify-content: flex-end;
  }

  .dialog-buttons > * {
    margin-left: var(--isceco-space-200);
  }

  i.close {
    color: var(--isceco-color-blue-500);
    padding: var(--isceco-space-200);
    margin: calc(var(--isceco-space-300) * -1);
    font-size: 1.75rem;
    cursor: pointer;
    float: right;
  }

  @media (max-width: 576px) {
    .dialog.small, .dialog.medium, .dialog.large {
      width: 300px;
    }
  }
  @media (min-width: 576px) {
    .dialog.small, .dialog.medium, .dialog.large {
      width: 450px;
    }
  }
  @media (min-width: 768px) {
    .dialog.small, .dialog.medium, .dialog.large {
      width: 600px;
    }
  }
  @media (min-width: 991.98px) {
    .dialog.medium, .dialog.large {
      width: 800px;
    }
  }
  @media (min-width: 1290.00px) {
    .dialog.small {
      width: 600px;
    }
    .dialog.medium {
      width: 800px;
    }
    .dialog.large {
      width: 1140px;
    }
  }

`;
export { ModalDialogCss as default };
